import { render, staticRenderFns } from "./OctPopover.vue?vue&type=template&id=cdfd93da&scoped=true&"
import script from "./OctPopover.vue?vue&type=script&lang=js&"
export * from "./OctPopover.vue?vue&type=script&lang=js&"
import style0 from "./OctPopover.vue?vue&type=style&index=0&id=cdfd93da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfd93da",
  null
  
)

export default component.exports